"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const iconContext = createContext({});
const useExtraIcons = () => useContext(iconContext);
const ExtraIconsProvider = ({ icons, children }) => jsx(iconContext.Provider, { value: icons, children });
export {
  ExtraIconsProvider,
  useExtraIcons
};
